/**
 * Weitzman collection: sort select, native filter form submission, mobile
 * filter drawer, and the ?q= search-term narrowing that arrives here from
 * the header's category+search combo. Extracted verbatim from
 * sections/weitzman-collection.liquid (only the section's own explanatory
 * Liquid {% comment %} blocks were converted to plain JS comments; no
 * Liquid interpolation was ever present in this script).
 */
(function () {
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
  const filterInputs = document.querySelectorAll('[data-filter-input]');
  filterInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      const form = input.closest('[data-filters-form]');
      if (!form) return;
      const url = new URL(window.location.href);
      const allInputs = form.querySelectorAll('input[type="checkbox"], input[type="number"]');
      allInputs.forEach(function (el) { url.searchParams.delete(el.name); });
      const checked = form.querySelectorAll('input[type="checkbox"]:checked, input[type="number"]');
      checked.forEach(function (el) {
        if (el.value !== '') url.searchParams.append(el.name, el.value);
      });
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  const panel = document.querySelector('[data-filters-panel]');
  const overlay = document.querySelector('[data-filters-overlay]');
  const toggle = document.querySelector('[data-filters-toggle]');
  if (panel && overlay && toggle) {
    /* Where focus was before the drawer opened, so it can be put back.
       Same pattern as the cart drawer in assets/weitzman-2026.js. */
    let lastFocus = null;

    function openFilters() {
      lastFocus = document.activeElement;
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      const closeBtn = panel.querySelector('[data-filters-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeFilters() {
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }
    toggle.addEventListener('click', openFilters);
    overlay.addEventListener('click', closeFilters);
    panel.querySelectorAll('[data-filters-close]').forEach(function (btn) {
      btn.addEventListener('click', closeFilters);
    });
    document.addEventListener('keydown', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeFilters(); return; }
      /* Without this, Tab walks straight out of the open drawer and into
         the page behind it, which is still visible but not meant to be
         reachable. */
      if (e.key === 'Tab' && window.WTZ && window.WTZ.trapFocus) {
        window.WTZ.trapFocus(panel, e);
      }
    });
  }

  /*
    Ketubah hub's 4 "Shop by X" tiles are pure triggers, not a second copy
    of the option list: clicking one just opens that group's real <details>
    in the sidebar built above (data-hub-group matches the tile's
    data-hub-open-group) and, if the sidebar is currently the mobile
    drawer (fixed position, same breakpoint as the CSS), opens it via the
    existing toggle button rather than duplicating that logic here.
  */
  const hubGroupTiles = document.querySelectorAll('[data-hub-open-group]');
  hubGroupTiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      const target = document.querySelector('[data-hub-group="' + tile.getAttribute('data-hub-open-group') + '"]');
      if (!target) return;
      if (panel && getComputedStyle(panel).position === 'fixed' && toggle) toggle.click();
      target.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });
})();

(function () {
  /*
    Narrows the page to cards whose title contains ?q= when arriving here
    from the header's category+search combo (weitzman-header.liquid routes
    a category pick straight to its collection, carrying the typed term as
    q instead of the old, broken product_type: search qualifier).

    Works two ways depending on layout: the flat grid (Grid layout, or Rows
    with a filter already active) just hides non-matching cards in place.
    Rows layout with no filter active has no flat grid at all by default,
    only curated subcollection_row carousels, so this used to silently do
    nothing for any category pointing at a department hub (Judaica, Books |
    Paper Goods, Gift Ideas at minimum). Falls back to narrowing each row's
    own cards and dropping any row left with nothing in it, searching only
    among the products already rendered in each row's sample (not the full
    collection), same real constraint the Grid path doesn't have.
  */
  const q = new URLSearchParams(window.location.search).get('q');
  if (!q) return;
  const needle = q.trim().toLowerCase();
  if (!needle) return;

  /*
    Naive English stemmer: "biography" is not a substring of "biographies"
    (the plural drops the y), so a plain indexOf check never matched a
    category's own plural heading against a shopper's singular search term.
    Strips the common plural suffixes so both sides compare on the same
    root word. Good enough for matching short category/product names, not
    meant to be a real stemmer.
  */
  function stem(word) {
    if (word.length > 4 && word.slice(-3) === 'ies') return word.slice(0, -3) + 'y';
    if (word.length > 3 && word.slice(-2) === 'es') return word.slice(0, -2);
    if (word.length > 3 && word.slice(-1) === 's') return word.slice(0, -1);
    return word;
  }
  const needleStem = stem(needle);

  function textMatches(text) {
    const normalized = text.toLowerCase();
    if (normalized.indexOf(needle) !== -1) return true;
    return normalized.split(/[^a-z0-9]+/).some(function (word) {
      return word && (stem(word) === needleStem || stem(word).indexOf(needleStem) !== -1);
    });
  }

  function cardMatches(card) {
    const link = card.querySelector('.wtz-card__link');
    const title = link ? (link.getAttribute('aria-label') || '') : '';
    return textMatches(title);
  }

  function insertNote(anchor, shown) {
    const note = document.createElement('p');
    note.className = 'wtz-col-qnote';
    note.textContent = shown
      ? 'Showing ' + shown + ' result' + (shown === 1 ? '' : 's') + ' for "' + q + '".'
      : 'No products match "' + q + '" in this collection.';
    const clear = document.createElement('a');
    clear.href = window.location.pathname;
    clear.textContent = 'Clear search';
    clear.className = 'wtz-col-qnote__clear';
    note.appendChild(document.createTextNode(' '));
    note.appendChild(clear);
    anchor.parentNode.insertBefore(note, anchor);
  }

  const grid = document.querySelector('.wtz-col-grid');
  if (grid) {
    let shown = 0;
    Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]')).forEach(function (card) {
      const matches = cardMatches(card);
      card.style.display = matches ? '' : 'none';
      if (matches) shown++;
    });
    insertNote(grid, shown);
    return;
  }

  const subrows = document.querySelector('.wtz-subrows');
  if (!subrows) return;
  const rows = Array.prototype.slice.call(subrows.querySelectorAll('.wtz-subrow'));

  /*
    A search like "biography" is looking for the curated category, not a
    literal word in any one book's title ("Golda: A Life" would never
    match "biography" on title alone), and each row only renders a small
    sample of its real collection anyway. So a heading match jumps
    straight to that row's own full collection page (its "View all" link)
    instead of filtering the handful of sample cards shown on this hub.
    Only a plain title search falls back to filtering the visible sample,
    the same real constraint the flat grid path doesn't have.
  */
  const matchedRow = rows.filter(function (row) {
    const titleEl = row.querySelector('.wtz-subrow__title');
    return titleEl && textMatches(titleEl.textContent);
  })[0];
  if (matchedRow) {
    const viewAll = matchedRow.querySelector('.wtz-subrow__viewall');
    if (viewAll && viewAll.href) {
      window.location.href = viewAll.href;
      return;
    }
  }

  let totalShown = 0;
  rows.forEach(function (row) {
    const cards = Array.prototype.slice.call(row.querySelectorAll('[data-product-card]'));
    let rowShown = 0;
    cards.forEach(function (card) {
      const wrap = card.closest('.wtz-subrow__card') || card;
      const matches = cardMatches(card);
      wrap.style.display = matches ? '' : 'none';
      if (matches) rowShown++;
    });
    row.style.display = rowShown ? '' : 'none';
    totalShown += rowShown;
  });
  insertNote(subrows, totalShown);
})();
